<template>
  <div class="list-item-container" :class="{ 'has-border': hasBorder, 'draggable': isDraggable }">
    <i class="fa fa-bars mr-3" />
    <div class="list-item-image">
      <ImageView
        :source="image" />
    </div>
    <div class="list-item-detail">
      <div class="list-item list-item-primary list-item-information">
        <div class="list-title">
          {{listTitle}}
        </div>
        <small class="list-primary-information">
          {{listPrimaryInformation}}
        </small>
        <!-- <small class="list-secondary-information">
          {{listSecondaryInformation}}
        </small> -->
      </div>
      <div class="list-item list-item-action">
        <div class="action-container">
          <slot name="button-action"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageView from '@/image/ImageView.vue';

export default {
  props: {
    image: {
      type: Object,
      default: null,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    listTitle: {
      type: String,
      default: '',
    },
    listPrimaryInformation: {
      type: String,
      default: '',
    },
    isDraggable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ImageView,
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/list-manage.scss';

.draggable {
  cursor: move;
}

.list-item-container {
  width: 100%;

  .list-item-information {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;

    .list-title {
      font-weight: bold;
      color: $gray-700;
      margin-bottom: $spacer * 0.25;
    }
    .list-primary-information {
      font-weight: bold;
      /* margin-bottom: $spacer * 0.125; */
    }
  }
}

.has-border {
  border-bottom: 1px solid $gray-100;
  padding: $spacer;
}

</style>
